export default __webpack_public_path__ + "static/media/Group 5796.4d0e63fb.svg";